module.exports = __webpack_public_path__ + "img/react.cb147c69.png";